// External
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { sortBy } from 'lodash';

// Internal
import NavBaseTemplate from '../templates/NavBaseTemplate';
import FeedbackTile from '../theme/modals/FeedbackTile';
import RowCard from '../cards/rowCard';
import DataTable from '../theme/tables/DataTable';
import { pullCampaignOffices, pullCampaignScripts } from '../../store/api/calls';
import {
  pullCampaignDoorCanvassPasses,
  pullCampaignDoorCanvasses,
  createPass,
  postDoorDataAction,
} from '../../store/api/calls/doors';
import PassModal from '../theme/modals/PassModal';

class DoorCanvassScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedOffice: 0,
      canvasses: [],
      allExpanded: false,
      passModalVisible: false,
      selectedCanvass: null,
    };

    this.DISPLAY_FORMAT = 'M/DD/YY';
    this.dateChangeTimeout = null;
  }

  pullData(force = false) {
    this.setState({ loading: true });
    let requests = [];

    pullCampaignScripts();

    if (force || !this.props.offices.length) {
      requests.push(pullCampaignOffices());
    }

    if (force || !this.props.doorCanvasses.length) {
      requests.push(pullCampaignDoorCanvasses());
    }

    if (force || !this.props.doorCanvassPasses.length) {
      requests.push(pullCampaignDoorCanvassPasses());
    }

    // get data from any previous requests that may not be present in props first
    if (requests.length) {
      Promise.all(requests)
        .then((data) => {
          this.buildData();
        })
        .catch((err) => this.setState({ loading: false }));
    } else {
      this.buildData();
    }
  }

  componentDidMount() {
    this.pullData(true);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.focusedCampaign !== this.props.focusedCampaign) {
      this.pullData(true);
    }
  }

  buildData() {
    let canvasses = {};

    // buld canvass object structure, associate and passes and then put in state.
    this.props.doorCanvasses.forEach((item, index) => {
      if (!canvasses[item.id]) {
        canvasses[item.id] = {
          id: item.id,
          title: item.name,
          office: item.office,
          passes: [],
          statuses: item.statuses,
        };
      }

      this.props.doorCanvassPasses.forEach((dcp) => {
        if (dcp.canvass.id === item.id) {
          dcp.agg_data = dcp.agg_data || {};
          canvasses[item.id].passes.push(dcp);
        }
      });
    });

    // they are sorted by keys to make it easier to group. Remove from dictionary, and you have an array of canvasses
    canvasses = Object.values(canvasses);

    this.setState({
      loading: false,
      selectedOffice: this.props.offices[0].id,
      canvasses,
    });
  }

  filterCards(data) {
    if (data.office === this.state.selectedOffice) {
      return data.data;
    } else {
      return [];
    }
  }

  handleActionSelect = (val) => {
    console.log('selected', val);
  };

  buildPassTable = (canvass) => {
    let { passes } = canvass;
    if (!passes) passes = [];

    let get_percent_of_total = (numerator, denominator) => {
      if (!numerator) return '0%';
      if (!denominator) return '--';
      return Math.round((numerator / denominator) * 100) + '%';
    };

    let tableData = passes.map((pass) => {
      console.log(pass);
      let getDisp = (metric, style) => {
        if (!metric) return '--';
        return (
          <span className={'flx is-flex-direction-column'} style={style}>
            <span className={'is-size-4'}>{metric}</span>
            <span className={'is-size-6'}>
              ({get_percent_of_total(metric, pass.household_count)})
            </span>
          </span>
        );
      };

      let { agg_data } = pass;
      let walkable_cut = agg_data.walkable_cut || 0;
      let unwalkable_cut = agg_data.unwalkable_cut || 0;
      let total_cut = walkable_cut + unwalkable_cut;
      let knocked = agg_data.attempted || 0;

      return {
        '✂': pass.is_locked ? (
          <div className="flx">
            <span className={'danger-text'}>LOCKED</span>
          </div>
        ) : (
          <Link to={`/turfcutter/${pass.id}`}>
            <div className={'button button-clear m-0 p-0'}>
              <div className={'flx'}>
                <i className="fa fa-cut fa-pull-right mr-2" title="Go To Turf Cutter" />
                <span>Cut Turf</span>
              </div>
            </div>
          </Link>
        ),
        name: <span className={'has-text-semibold'}>{pass.name}</span>,

        total_doors: getDisp(pass.household_count),
        knocked: getDisp(knocked),
        cut_doors: getDisp(total_cut),
        walkable_cut: getDisp(walkable_cut),
        unwalkable_cut: getDisp(unwalkable_cut),
        walkable_turfs: getDisp(agg_data.walkable_turfs),
        unwalkable_turfs: getDisp(agg_data.unwalkable_turfs),
      };
    });

    return (
      <DataTable
        title={`Script:  ${
          this.props.scripts.find((script) => script.id === canvass.passes[0].canvass.script)?.name
        }`}
        data={tableData}
      />
    );
  };

  onCreatePass = (create_info) => {
    // "msg": {
    //   "type": "NEW_PASS",
    //       "parent_pass_id": 450,
    //       "filter_info": "--",
    //       "new_pass_name": "Autogenerated new pass from lambda tests",
    //       "statuses_to_remove": "refused and canvassed"

    // new_pass_name: "First Prod DB Canvass Pass 2"
    // parent_pass_id: 1
    // statuses: (5) ['canvass', 'moved', 'refused', 'language_barrier', 'do_not_walk']
    //     [[Prototype]]: Object
    // }

    const data_to_dispatch = {
      ...create_info,
      statuses_to_remove: create_info.statuses,
      filter_info: 'Removed ' + create_info.statuses.join(', ') + '.',
      type: 'NEW_PASS',
    };

    postDoorDataAction(data_to_dispatch).then(() => null);
  };

  renderCards() {
    let result = [];

    sortBy(this.state.canvasses, ['title', 'id']).forEach((canvass, index) => {
      if (!canvass.passes || !canvass.passes.length) return;

      result.push(
        <div className={'doorcanvass-set mb-6 pb-4'}>
          <div className="button-table-top-wrapper flx space_between is-align-items-center">
            <h4 className="mb-0">{canvass.title}</h4>
            <div>
              <Link to={`/doorcanvass/${canvass.id}/schedule`}>
                <button
                  data-testid={'doors-schedule-' + index}
                  className={'button button-outline primary-text mb-0'}
                >
                  Schedule Canvass
                </button>
              </Link>
              {this.props.is_admin && (
                <button
                  onClick={() => {
                    this.setState({
                      passModalVisible: true,
                      selectedCanvass: canvass,
                    });
                  }}
                  className={'button button-outline primary-milligram-text ml-4'}
                >
                  New Pass
                </button>
              )}
            </div>
          </div>

          {this.buildPassTable(canvass)}
        </div>
      );
    });

    if (!result.length && !this.state.loading) {
      return <RowCard columns={[{ text: 'This office does not have any door canvasses' }]} />;
    }

    return result;
  }

  render() {
    return (
      <NavBaseTemplate location={this.props.location} showAdmin={this.props.is_admin}>
        <div className={'button-table-top-wrapper'}>
          {/*<a href={'/doors-upload'} className={'button'}>*/}
          {/*  + Upload Doors Data*/}
          {/*</a>*/}
        </div>
        {this.renderCards()}
        <FeedbackTile
          text={
            <div>
              <i className="fas fa-asterisk fa-spin" style={{ marginRight: '15px' }} />
              Loading...
            </div>
          }
          visible={this.state.loading || this.props.doorCanvassPassLoading}
        />

        {/*use feedback tile icon, text, state*/}
        <FeedbackTile
          text={
            <div>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: '15px' }} />
              There was a server error.
            </div>
          }
          visible={false}
          backgroundColor={'red'}
        />
        {this.state.passModalVisible && (
          <PassModal
            handlePassModalClose={() => this.setState({ passModalVisible: false })}
            onSubmit={(create_info) => this.onCreatePass(create_info)}
            canvass={this.state.selectedCanvass}
          />
        )}
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.session.campaigns,
  focusedCampaign: state.session.focusedCampaign,
  is_admin: state.permissions.is_admin,
  offices: state.offices.data,
  doorCanvasses: state.doorCanvasses.data,
  doorCanvassPasses: state.doorCanvassPasses.data,
  doorCanvassPassLoading: state.doorCanvassPasses.loading,
  scripts: state.scripts.data,
});

export default connect(mapStateToProps)(DoorCanvassScreen);
